export default "__VITE_ASSET__DKrcRxzC__"